// One-time flag so the Sign In page can say "Your session expired" after an
// expired session sends the user there (sign-out redirect, stale tokens)
const KEY = 'naa-session-expired';

/** Remember that the session expired, for the next Sign In page load */
export function markSessionExpired() {
  try {
    sessionStorage.setItem(KEY, '1');
  } catch (error) {
    // Storage blocked: the notice just won't show
  }
}

/** Read and clear the flag (or `?reason=expired` in the URL) */
export function consumeSessionExpired() {
  let expired =
    new URLSearchParams(window.location.search).get('reason') === 'expired';
  try {
    expired = expired || sessionStorage.getItem(KEY) === '1';
    sessionStorage.removeItem(KEY);
  } catch (error) {
    // Storage blocked: rely on the URL only
  }
  return expired;
}

/**
 * True when Amplify left Cognito session keys behind, i.e. there was a
 * session in this browser that can no longer be restored. A user who signed
 * out has none (Amplify clears them).
 */
export function hasStaleCognitoSession() {
  try {
    return Object.keys(localStorage).some(
      (key) =>
        key.startsWith('CognitoIdentityServiceProvider.') &&
        key.endsWith('.LastAuthUser'),
    );
  } catch (error) {
    return false;
  }
}
